import { SectionRegistrationAttributesQuery } from '../../../../registration_attributes/queries/section_registration_attributes_query';
import { TermScheduleFlags } from '../../../course_scheduler/services/term_schedule_flags';
import { ICommand } from 'core-ts-types';
import { ISectionAvailability } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant } from '../../../sections/servants/section_info_servant';
import { TermCourseServant } from '../../../term_courses/servants/term_course_servant';
import { UnscheduledSectionServant } from '../../servants/unscheduled_section_servant';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { OpenModalFlag } from '../../../course_scheduler/components/calendar_placeholder_alert/openModalFlag';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { MeetingTimeServant } from '../../../../components/meeting_times/servants/meeting_time_servant';
import { ScreenQueryServant } from 'screen-query';
// Notes

/*
  TODO:
  Pass everything into the section, reduce DI
  Check for Multi-section(sho/hide badge) should come from parent
  Use string utility for truncation
  Use string utility for pluralize
  Use time utility for formatting time
  Move section Tile info composition to a helper utility for both unscheduled and scheduled sections
  Upgrade to route based modal for section details.
  Move add to waitlist to parent and pass callback into tile
  Conflicting sections are needed in section details.
  */

interface IDropdownMenuConfig {
  action: string;
  title: string;
  enabled: boolean;
}

export class UnscheduledSectionTile {
  private section: ISection & ISectionAvailability;
  private availability: any;
  private locationAndTimes: any;
  private canAddToWaitlist: any;
  private isMultiSection: boolean;
  private sectionLabel: string;
  private fullLocationString: string;
  private sectionLocation: string;
  private sectionCampus: string;
  private canDrag: boolean | null;
  private conflictingMessages: any;
  private conflictingDisplayMessage: string;
  private conflictingMessageStyle: string = '';
  private isConflicting: boolean;
  private showActionButton: boolean;
  private isSwapMode: boolean;
  private courseTime: string;
  private dragging: boolean;
  private sectionTitle: string = '';
  private isSectionFull: boolean = false;
  private showSectionFullBanner: boolean = false;
  private previewMode: boolean = false;
  private hasMultipleMeetingTimes: boolean = false;
  private closeSectionModalBound: () => void;
  private showRegAttrs?: boolean = false;
  private parentForm?: string;

  private dropDownMenuItems: IDropdownMenuConfig[] = [];
  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private FEATURE_SECTION_LABEL_NK: any,
    private schedulerConfigModel: any,
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngTermCourseServant: TermCourseServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngMeetingTimeServant: MeetingTimeServant,
    private ngScreenQueryServant: ScreenQueryServant,
    private waitlistSectionCommand: ICommand,
    private saveTermPinCommand: ICommand,
    private updateSeatAvailabilityCommand: ICommand,
    private getCrossCourseLinkedSectionsCommand: ICommand,
    private clearCrossCourseLinkedSectionsCommand: ICommand,
    private ngOpenModalFlag: OpenModalFlag,
    private $timeout: ng.ITimeoutService,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSectionRegistrationAttributesQuery: SectionRegistrationAttributesQuery
  ) {}

  initialize() {
    // section times from server contain from and to times and indicate day of week through an integer
    this.locationAndTimes = this.ngSectionInfoServant.calculateSectionTimes(this.section);
    this.isSwapMode = _4.includes(this.$state.current.name || '', 'swap');
    this.showActionButton = !this.isSwapMode;
    this.availability = this.section._availability;
    this.canAddToWaitlist = this.ngUnscheduledSectionServant.canAddToWaitlist(this.section);
    this.isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    this.sectionLabel = this.schedulerConfigModel.getConfigProperty(this.FEATURE_SECTION_LABEL_NK);
    this.fullLocationString = this.ngSectionInfoServant.getSectionLocationString(this.section);
    this.sectionLocation = this.fullLocationString;
    this.sectionCampus = this.ngSectionInfoServant.getSectionCampus(this.section);
    this.canDrag =
      this.ngUnscheduledSectionServant.canDragSection(this.section) &&
      this.section.status !== 'SECTION_PICKED' &&
      this.ngScreenQueryServant.isScreenDesktop();
    this.conflictingMessages = this.ngSectionInfoServant.getConflictingMessages(this.section);
    // Pick the first message they are inf priority.
    this.conflictingDisplayMessage = _4.get(this.conflictingMessages[0], 'message');
    this.conflictingMessageStyle = _4.get(this.conflictingMessages[0], 'style');
    this.isConflicting = this.ngUnscheduledSectionServant.isSectionConflicting(this.section);
    this.courseTime = this.ngSectionInfoServant.sectionCourseTime(this.section);
    this.isSectionFull = this.ngUnscheduledSectionServant.isSectionFull(this.section);
    this.showSectionFullBanner = this.ngTermScheduleFlags.isFullSectionsSchedulingEnabled() && this.isSectionFull;

    this.sectionTitle = `${_4.get(this.section, '_course.cd', '')} - ${this.sectionLabel} ${_4.get(
      this.section,
      'cd',
      ''
    )}`;

    this.hasMultipleMeetingTimes = this.ngMeetingTimeServant.hasMultipleMeetingTimes(this.section);
    this.buildDropdownItems();
  }
  $onInit() {
    this.initialize();
    this.closeSectionModalBound = this.closeSectionDetailModal.bind(this);
    this.ngComponentCommunicatorService.subscribe('CLOSE_SECTION_DETAIL_MODAL', this.closeSectionModalBound);
  }

  $onChanges(changes: { section: ISection }) {
    this.initialize();
  }

  buildDropdownItems() {
    this.dropDownMenuItems = [];
    this.dropDownMenuItems.push({
      action: 'view_section_details',
      title: 'Details',
      enabled: true
    });
  }

  closeSectionDetailModal() {
    this.clearCrossCourseLinkedSectionsCommand();
  }

  getCrossCourseLinkedSections() {
    if (_4.get(this.section, '_availability.has_linked_section_coreqs', false)) {
      this.getCrossCourseLinkedSectionsCommand(this.section.id);
    }
  }
}

class UnscheduledSectionTileComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<',
      dragging: '<',
      previewMode: '@',
      showRegAttrs: '@?',
      parentForm: '@?'
    };

    this.controller = UnscheduledSectionTile;
    this.templateUrl =
      'capability-ng-scheduler/src/views/unscheduled_sections/components/unscheduled_section_tile/unscheduled_section_tile.html';
  }
}
angular.module('capability-ng-scheduler').component('unscheduledSectionTile', new UnscheduledSectionTileComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/components/unscheduled_section_tile/unscheduled_section_tile.ts